import { Box } from "@mui/material";

export const GridBreak = () => <Box width="100%"/>;